import {createErrorAction} from './utils';

const TYPES = {
    GET_LIFETIME_PLAYS: 'GET_LIFETIME_PLAYS',
    GET_LIFETIME_PLAYS_COMPLETE: 'GET_LIFETIME_PLAYS_COMPLETE',
    GET_LIFETIME_PLAYS_FAILED: 'GET_LIFETIME_PLAYS_FAILED',
    RESET_DATA: 'LIFETIME_PLAYS_RESET_DATA'
};

export default {
    TYPES,

    getLifetimePlays: payload => ({
        type: TYPES.GET_LIFETIME_PLAYS,
        payload
    }),

    getLifetimePlaysSuccess: payload => ({
        type: TYPES.GET_LIFETIME_PLAYS_COMPLETE,
        payload
    }),

    getLifetimePlaysFailed: createErrorAction(TYPES.GET_LIFETIME_PLAYS_FAILED),

    resetData: () => ({
        type: TYPES.RESET_DATA
    })
};
